// Mock data for Collins Technologiez clone (frontend-only)
import {
  Laptop, Printer, Settings, FileText, HardDrive, Monitor, Bug,
  Tv, Wrench, Truck, Smartphone, Search
} from 'lucide-react';

export const CONTACT = {
  phone: '7134385594',
  phoneDisplay: '(713) 438-5594',
  email: 'collinstechnologiez@gmail.com',
  smsBody: encodeURIComponent("Hi! I'd like a repair quote. My device is a [Model] and the problem is [Describe Issue]."),
  serviceArea: 'Mobile service across Houston & surrounding areas',
  hours: [
    { days: 'Mon \u2013 Fri', time: '6:00 PM \u2013 10:00 PM' },
    { days: 'Sat \u2013 Sun', time: '10:00 AM \u2013 6:00 PM (call or text)' },
  ],
};

export const NAV_LINKS = [
  { label: 'Services', href: '#services' },
  { label: 'Process', href: '#process' },
  { label: 'Why Us', href: '#why-us' },
  { label: 'Reviews', href: '#reviews' },
  { label: 'For Sale', href: '#for-sale' },
  { label: 'Contact', href: '#contact' },
  { label: 'Pay', href: '/pay' },
];

export const FEATURES = [
  { title: '90-Day Warranty', desc: 'Peace of mind included on every repair.' },
  { title: 'We Come to You', desc: 'Free mobile service in the local area.' },
  { title: 'No Repair, No Fee', desc: "If we can't fix it, you don't pay a cent." },
];

export const SERVICES = [
  { id: 'svc-laptop-setup', icon: Laptop, tag: 'Per Service', title: 'Laptop/Tablet Setup', desc: 'Apple & PC \u2013 Laptop/Tablet Setup', price: '$60.00' },
  { id: 'svc-printer-setup', icon: Printer, tag: 'Per Service', title: 'Printer Setup', desc: 'Full printer installation & configuration', price: '$40.00' },
  { id: 'svc-pc-tuneup', icon: Settings, tag: 'Per Service', title: 'PC Tune-Up', desc: 'Deep diagnostic + performance restore', price: '$60.00' },
  { id: 'svc-mac-tuneup', icon: Settings, tag: 'Per Service', title: 'Mac Tune-Up', desc: 'Optimization & cleanup for macOS', price: '$80.00' },
  { id: 'svc-office-win', icon: FileText, tag: 'Windows', title: 'Microsoft Office Pro', desc: 'Office Pro installation \u2013 Windows', price: '$60.00' },
  { id: 'svc-office-mac', icon: FileText, tag: 'Mac', title: 'Microsoft Office Pro', desc: 'Office Pro installation \u2013 Mac', price: '$80.00' },
  { id: 'svc-windows-os', icon: HardDrive, tag: 'Per Service', title: 'Windows OS Installation', desc: 'Full Windows OS install & setup', price: '$60.00' },
  { id: 'svc-osx-install', icon: Monitor, tag: 'Per Service', title: 'Apple OSX Installation', desc: 'macOS reinstall & configuration', price: '$80.00' },
  { id: 'svc-virus-removal', icon: Bug, tag: 'Per Service', title: 'Virus/Spyware Removal', desc: 'Complete malware cleanup & protection', price: '$80.00' },
  { id: 'svc-tv-mounting', icon: Tv, tag: 'On Quote', title: 'TV Mounting', desc: 'Professional TV wall mounting \u2014 varies by size & features needed', price: 'Varies' },
  { id: 'svc-hardware-repair', icon: Wrench, tag: 'Varies', title: 'Hardware Repair', desc: 'Labor + price of parts', price: 'From $80.00' },
  { id: 'svc-diagnostic', icon: Search, tag: 'Free if serviced', title: 'Diagnostic', desc: 'Full system diagnostic & assessment', price: '$40.00' },
  { id: 'svc-travel-charge', icon: Truck, tag: 'Per Visit', title: 'Travel Charge', desc: 'House & small business calls', price: '$25.00' },
  { id: 'svc-cellphone-repair', icon: Smartphone, tag: 'On Quote', title: 'Cell Phone & Tablet Repair', desc: 'Screen, battery, charging port, water damage & more', price: 'Quoted on arrival' },
];

export const PROCESS = [
  { n: '01', title: 'Tell Us the Issue', desc: "Text or call. We'll ask a few diagnostic questions." },
  { n: '02', title: 'Free Quote', desc: 'Transparent flat-rate pricing \u2014 no surprise fees.' },
  { n: '03', title: 'We Fix It', desc: 'Mobile service or drop-off. Most repairs same day.' },
  { n: '04', title: '90-Day Warranty', desc: 'If anything goes wrong, we make it right.' },
];

export const WHY_POINTS = [
  'Certified technicians with 10+ years experience',
  'Genuine grade replacement parts',
  'Anti-static workstation & ESD-safe handling',
  'Free no-obligation diagnostics',
  'Local & independently owned',
  'Most repairs completed same or next business day',
];

export const STATS = [
  { value: '500+', label: 'Repairs' },
  { value: '4.9\u2605', label: 'Rating' },
  { value: '90d', label: 'Warranty' },
];

export const REVIEWS = [
  { id: 'rev-marsha-b', text: "I had a major issue with my computer\u2014it suddenly went black and I had no clue what was wrong. The guy here is incredibly knowledgeable and professional. He quickly assessed the problem, identified that the motherboard had gone out, and was able to fix it without the hassle or huge price tag. Highly recommend\u201410 out of 10 service!", name: 'MARSHA B' },
  { id: 'rev-shamicia-w', text: "Two thumbs up\u2026 10/10 recommend! I let Mr Collin's know the problem I was having with my laptop\u2026 a cracked screen and it wouldn't come on at all. Fast, friendly, fixed! Great communication throughout the process. Very satisfied customer.", name: 'SHAMICIA W' },
  { id: 'rev-sabrina-h', text: 'Excellent customer service, extremely knowledgeable, stays current on up to date technology, and efficient in handling all aspects of computer repair services.', name: 'SABRINA H' },
  { id: 'rev-rodshunn-d', text: "Great experience! I purchased a laptop and it's still kicking like new 5 years later! Great service and great people! I totally recommend Collin's Technologiez for all purchases and repairs!", name: 'RODSHUNN D' },
  { id: 'rev-helen-w', text: "His service is honest, great customer service, always stays in communication to let you know if prices change. I've been going to him for years and he is the only one that touched my devices. Service always 10 out of 10", name: 'HELEN W' },
  { id: 'rev-jerlean-m', text: 'Very professional and Trust Worthy. Best Hands Down.', name: 'JERLEAN M' },
  { id: 'rev-jamila-d', text: "Been doing business with this man for years and he always has great customer service. I've purchased numerous phones, iPads, and even a desktop computer from him not to mention the numbers of times I've needed a phone repaired.", name: 'JAMILA D' },
  { id: 'rev-latoya-w', text: 'I purchased a laptop during the pandemic for my son that worked great. And I purchased an iPhone for my son that he has barely put down in this past year. LOL. Always professional and thorough. We will definitely do business again.', name: 'LATOYA W' },
];

export const INVENTORY = [
  { id: 'inv-macbook-2014', name: 'MacBook Pro (2014)', price: '$200', desc: '15" Retina MacBook Pro (2014) with Intel Core i5, 16 GB RAM, and 256 GB SSD. Professionally refurbished, fully functional with backlit keyboard, Force Touch trackpad, and MagSafe 2 charging. Contact for availability.', soldOut: false },
  { id: 'inv-iphone-11', name: 'Apple iPhone 11 \u2014 White', price: '$160', desc: 'Restored Apple iPhone 11 in White, carrier unlocked, 64 GB. 6.1" Liquid Retina HD display, A13 Bionic chip, dual 12 MP cameras with Night mode, Face ID, IP68 water resistance, and wireless charging. Refurbished in like-new condition. Contact for availability.', soldOut: false },
];
